import { render } from "./pop-up-change-pass.vue?vue&type=template&id=4d52d796&scoped=true"
import script from "./pop-up-change-pass.vue?vue&type=script&lang=js"
export * from "./pop-up-change-pass.vue?vue&type=script&lang=js"

import "./pop-up-change-pass.vue?vue&type=style&index=0&id=4d52d796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d52d796"]])

export default __exports__